import React from 'react';
import { Link } from 'react-router-dom';
const LandingPicture = () => {
  return (
    <section className="landing-image-section">
      <div className="landing-desc container">
        <h1>Tradycyjnie smaczne</h1>
        <h3>
          Od wielu lat nasza firma specjalizuje się w rozbiorze i przetwórstwie
          wysokiej jakości starannie wyselekcjowanego mięsa. Wielkośc zakładu
          oraz receptury pezekazywane z pokolenia na pokolenie pozwalają nam
          tworzyć niepowtarzalny smak tradycyjnie wędzonych wędlin.
        </h3>
        <button>
          <Link to="/oferta"> SPRAWDŹ NASZĄ OFERTĘ </Link>
        </button>
      </div>
    </section>
  );
};

export default LandingPicture;
